module.exports = __webpack_public_path__ + "img/down.3eb7dda.png";